// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styleHelpers-borderRadius_cls1__1Eoq0","cls2":"styleHelpers-borderRadius_cls2__3QwL9 styleHelpers-borderRadius_cls1__1Eoq0"};